import React from 'react';
import { DefaultButton } from 'office-ui-fabric-react';
import { Col } from 'react-flexbox-grid';
import { ModalPagoEfectivo } from './ModalPagoEfectivo';

export const PagarPagoEfectivo = ({handlePagoEfectivo, enablePE, modal, closeModal, urlCIP}) => {
  return (
    <>
      <Col xs={12} sm={3}>
        <DefaultButton
          className="start-js-btn2 modal-opener default"
          text="PagoEfectivo"
          onClick={handlePagoEfectivo}
          disabled={!enablePE}
        ></DefaultButton>
        <br></br>
        <br></br>
        <img
          src="https://prod.cds.pagoefectivo.g3c.pe/img/general/pagoefectivo-logo.png?v=i7amcvxj6tk"
          alt="LogoPagoEfectivo"
          width="100%"
        ></img>
      </Col>
      <ModalPagoEfectivo 
        modal={modal} 
        closeModal={closeModal} 
        urlCIP={urlCIP} 
      />
    </>
    
  )
}
